import { render, staticRenderFns } from "./PrimeLog.vue?vue&type=template&id=7390d62c&scoped=true&"
import script from "./PrimeLog.vue?vue&type=script&lang=js&"
export * from "./PrimeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390d62c",
  null
  
)

export default component.exports